import { Component, Input } from '@angular/core';
import { Booking } from 'src/app/core/booking.service';
import { startOfDay, endOfDay } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unit-details-calendar-cell',
  templateUrl: './unit-details-calendar-cell.component.html',
  styleUrls: ['./unit-details-calendar-cell.component.scss'],
})
export class UnitDetailsCalendarCellComponent {
  @Input() day?: Date;
  @Input() day_number?: number;
  @Input() day_label?: string;
  @Input() bookings?: Booking[];

  translated_day_label?: string;

  constructor(private translate_service: TranslateService) {}

  ngOnInit(): void {
    this.translate_service.get(this.day_label || '').subscribe({
      next: translation => {
        this.translated_day_label = translation;
      },
    });
  }

  onCellClick(): void {}

  getCellBookings(): Booking[] {
    if (this.day) {
      const start_time = startOfDay(this.day).getTime();
      const end_time = endOfDay(this.day).getTime();

      const cell_bookings: Booking[] | undefined = this.bookings?.filter((booking: Booking) => {
        return booking.start_date && booking.start_date >= start_time && booking.start_date <= end_time;
      });

      return cell_bookings || [];
    }

    return [];
  }
}
